import type { ReactNode } from 'react'
import React from 'react'

import { Icon } from '@fourthwall/components'
import { ExclamationMarkIcon } from '@fourthwall/icons'

import * as S from './styled'

export type ForbiddenRouteStateProps = {
  title?: string
  subtitle?: ReactNode
}

export const ForbiddenRouteState = ({
  title = 'Page not found',
  subtitle = 'The page you’re looking for doesn’t exist or you don’t have permissions to access it.',
}: ForbiddenRouteStateProps) => (
  <S.Container>
    <Icon component={ExclamationMarkIcon} height={30} />
    <S.Title>{title}</S.Title>
    <S.Subtitle>{subtitle}</S.Subtitle>
  </S.Container>
)
